import React, { FC } from "react";

import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";

import { commonStyles } from "theme/common";

interface TitleProps {
    title: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) => {
    return {
        title: {
            color: theme.palette.primary.main,
        },
        ...commonStyles(theme),
    };
});

const Title: FC<TitleProps> = ({ title }) => {
    const classes = useStyles();

    return (
        <Typography variant="body1" className={classes.title}>
            {title}
        </Typography>
    );
};

export default Title;
